'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHoc = require('@mindz/react-hoc');

var _reactBeautifulDnd = require('react-beautiful-dnd');

var _UploadGalleryModule = require('./UploadGallery.module.css');

var _UploadGalleryModule2 = _interopRequireDefault(_UploadGalleryModule);

var _SnakeLoader = require('../SnakeLoader');

var _SnakeLoader2 = _interopRequireDefault(_SnakeLoader);

var _Dropzone = require('./components/Dropzone');

var _Dropzone2 = _interopRequireDefault(_Dropzone);

var _Tile = require('./components/Tile');

var _Tile2 = _interopRequireDefault(_Tile);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UploadGallery = function (_Component) {
  _inherits(UploadGallery, _Component);

  function UploadGallery() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UploadGallery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UploadGallery.__proto__ || Object.getPrototypeOf(UploadGallery)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loadingFiles: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UploadGallery, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cx = _props.cx,
          tiles = _props.tiles,
          base64 = _props.base64,
          isDraggable = _props.isDraggable;
      var isLoading = Object.keys(base64).length < tiles.length;
      return _react2.default.createElement('div', {
        className: cx('root', {
          isDraggable: isDraggable
        })
      }, !isLoading && this.renderDragDropContext(), isLoading && _react2.default.createElement('span', {
        className: cx('loading-images')
      }, _react2.default.createElement(_SnakeLoader2.default, null)));
    }
  }, {
    key: 'renderDragDropContext',
    value: function renderDragDropContext() {
      var _this2 = this;

      var _props2 = this.props,
          isDraggable = _props2.isDraggable,
          isDropzoneFirst = _props2.isDropzoneFirst,
          tiles = _props2.tiles,
          base64 = _props2.base64,
          handleGetListStyle = _props2.handleGetListStyle,
          handleOnDragEnd = _props2.handleOnDragEnd;

      var content = function content(_ref2) {
        var placeholder = _ref2.placeholder;
        return _react2.default.createElement('div', {
          style: handleGetListStyle()
        }, isDropzoneFirst && _this2.renderDropzone(), tiles && Object.keys(base64).length >= tiles.length && _react2.default.Children.map(tiles, function (child, index) {
          return _this2.renderDraggable({
            child: child,
            index: index
          });
        }), placeholder, _this2.renderProgress(), !isDropzoneFirst && _this2.renderDropzone());
      };

      if (!isDraggable) {
        return content({});
      }

      return _react2.default.createElement(_reactBeautifulDnd.DragDropContext, {
        onDragEnd: handleOnDragEnd
      }, _react2.default.createElement(_reactBeautifulDnd.Droppable, {
        droppableId: 'droppable',
        direction: 'horizontal'
      }, function (provided, snapshot) {
        return _react2.default.createElement('div', _extends({
          ref: provided.innerRef,
          style: handleGetListStyle(snapshot.isDraggingOver)
        }, provided.droppableProps), content({
          placeholder: provided.placeholder
        }));
      }));
    }
  }, {
    key: 'renderDraggable',
    value: function renderDraggable(_ref3) {
      var _this3 = this;

      var child = _ref3.child,
          index = _ref3.index;
      var isDraggable = this.props.isDraggable;

      var tiles = function tiles(_ref4) {
        var provided = _ref4.provided,
            snapshot = _ref4.snapshot;
        return _this3.renderTile({
          tile: child,
          provided: provided,
          snapshot: snapshot
        });
      };

      if (!isDraggable) {
        return tiles({});
      }

      return _react2.default.createElement(_reactBeautifulDnd.Draggable, {
        key: index,
        draggableId: index + '_' + child.props.url,
        index: index
      }, function (provided, snapshot) {
        return tiles({
          provided: provided,
          snapshot: snapshot
        });
      });
    }
  }, {
    key: 'renderTile',
    value: function renderTile(_ref5) {
      var tile = _ref5.tile,
          _ref5$provided = _ref5.provided,
          provided = _ref5$provided === undefined ? {} : _ref5$provided,
          _ref5$snapshot = _ref5.snapshot,
          snapshot = _ref5$snapshot === undefined ? {} : _ref5$snapshot;
      var _props3 = this.props,
          base64 = _props3.base64,
          handleGetItemStyle = _props3.handleGetItemStyle;
      var styles = provided && provided.draggableProps ? handleGetItemStyle(snapshot.isDragging, provided.draggableProps.style) : {};
      return _react2.default.createElement('div', _extends({
        ref: provided.innerRef
      }, provided.draggableProps, provided.dragHandleProps, {
        style: styles
      }), _react2.default.cloneElement(tile, _extends({}, tile.props, {
        url: base64[tile.props.url] ? base64[tile.props.url] : tile.props.url
      })));
    }
  }, {
    key: 'renderDropzone',
    value: function renderDropzone() {
      var _this4 = this;

      var _props4 = this.props,
          _handleUploadProgress = _props4.handleUploadProgress,
          _handleUploadSuccess = _props4.handleUploadSuccess,
          _handleUploadFailure = _props4.handleUploadFailure;
      return _react2.default.createElement(_Dropzone2.default, _extends({}, this.props, {
        cx: null,
        handleUploadProgress: function handleUploadProgress(state) {
          return _this4.setState({
            loadingFiles: state.files
          }, function () {
            return _handleUploadProgress && _handleUploadProgress(state);
          });
        },
        handleUploadSuccess: function handleUploadSuccess(state) {
          return _this4.setState({
            loadingFiles: []
          }, function () {
            return _handleUploadSuccess && _handleUploadSuccess(state);
          });
        },
        handleUploadFailure: function handleUploadFailure(state) {
          _this4.setState({
            loadingFiles: []
          }, function () {
            return _handleUploadFailure && _handleUploadFailure(state);
          });
        }
      }));
    }
  }, {
    key: 'renderProgress',
    value: function renderProgress() {
      var loadingFiles = this.state.loadingFiles;
      var cx = this.props.cx;
      return loadingFiles.map(function (file, index) {
        return _react2.default.createElement('div', {
          key: index
        }, _react2.default.createElement(_Tile2.default, null, _react2.default.createElement(_Dropzone2.default.Progress, null)));
      });
    }
  }]);

  return UploadGallery;
}(_react.Component);

exports.default = (0, _reactHoc.withStyles)(_UploadGalleryModule2.default)(UploadGallery);
module.exports = exports.default;